import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {PageTitleService} from "../../services/PageTitle";
import {Session} from "../../services/Session";
import {takeUntil} from "rxjs/operators";
import {StateService} from "../../services/StateService";
import {Router} from "@angular/router";
import {SwitchBoard} from "../../services/SwitchBoard";
import {TOAST_TYPE} from "../../constants/Tpiq.constants";
import {ToastService} from "../../services/Toast.service";

declare var _: any;
declare let jQuery: any;

@Component({
  selector: 'app-manage-integrations',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './manage-integrations.component.html',
  styleUrl: './manage-integrations.component.scss'
})
export class ManageIntegrationsComponent implements OnInit, OnDestroy {
  org: string;
  userId: string;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  routeSub: any;
  hiddenAPIKey = false;
  hiddenAPIKeyValue = '';
  apiKey = '';
  copyUrl: string;

  constructor(private titleService: PageTitleService, private stateService: StateService, private _router: Router,
              private switchBoard: SwitchBoard, private toastService: ToastService) {
  }

  ngOnInit() {
    this._init();
  }

  _init() {
    this.org = Session.getOrg();
    this.userId = Session.getUser().id;
    this.titleService.setPageTitle('Integrations');
    this.switchBoard.onPageChangeListener.next({});
    this.switchBoard.onClickPrev
      .pipe(takeUntil(this.destroy$)).subscribe(title => {
      this.gotoDefaultPage();
    });
  }

  gotoDefaultPage() {
    const prevState = this.stateService.getPrevState();
    if (prevState) {
      this.stateService.pop();
      this._router.navigate([prevState.url]);
    }
  }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggle() {
    if (!this.hiddenAPIKey) {
      let key = _.cloneDeep(this.apiKey);
      this.hiddenAPIKeyValue = key.replaceAll(".(?=.{4})", "x");
    }
    this.hiddenAPIKey = !this.hiddenAPIKey;
  }

  copyAPIKey() {
    this.copyUrl = this.apiKey;
    setTimeout( () => {
      jQuery('#apiKeyCopy').select();
      document.execCommand('copy');
      this.toastService.pop(TOAST_TYPE.success, 'Zapier API Key Copied');
    });
  }

  openConnectionUrl() {
    const link = 'https://zapier.com/developer/public-invite/181493/be0d569c68b83ad168669d2a4e5b0f12/';
    window.open(link, '_blank');
  }

}
